import React from 'react';
import './CalendlyButton.css';

const CalendlyButton = () => {
  return (
    <div className="custom-sticky-cal">
      <a href="https://calendly.com/ai-area4u/30min" target="_blank" rel="noopener noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>Consultanță Startup</span>
      </a>
    </div>
  );
};

export default CalendlyButton;
